export default __webpack_public_path__ + "static/media/icon-arrow-button-left.2146f2d3.svg";